export default "__VITE_ASSET__DPHl9d62__"